import { differenceInYears } from 'date-fns';

export const differenceInYearsResult = (date?: string | null) => {
    if (!date) return 0;
    const startDate = new Date(date);
    const currentDate = new Date();

    return differenceInYears(currentDate, startDate);
};
